<template>
  <div class="mobile">
    <v-touch v-on:swipeleft="leftSlide" v-on:swiperight="rightSlide" class="v-touch">
      <div class="detail" v-if="show" ref="detail" v-touch:swipeup="() => (showInfo = false)"
        v-touch:swipedown="() => (showInfo = false)" v-touch:press="press">
        <div class="img" @click="hideInfo">
          <img :src="imgUrl" alt="" srcset="" />
          <!-- <img src="~@/assets/images/demo/test.jpg" alt="" srcset=""> -->
          <!-- <div class="img-bottom"></div> -->
        </div>
        <div class="img-info" v-show="showInfo">
          <div class="title text-overflow-ellipsis">{{ title }}</div>
          <div class="text text-overflow-ellipsis">{{ detailText }}</div>
        </div>
        <div class="footer" v-show="showInfo">
          <div class="left" @click="collectChange">
            <span :class="{collect: true, hasCollect: hasCollect}"> </span>
            <span
              class="text">{{ !hasCollect ? (collectNum == 0 ? $t('ae336cd047') : collectNum) : $t('934ebd87e6') }}</span>
          </div>
          <div class="right" @click="changeArticle(true)">
            <span class="text">{{ $t('5442a970ed') }}</span>
            <span class="logo"></span>
          </div>
        </div>
        <div class="zhe" v-show="showInfo" @click="hideInfo"></div>
        <div class="article" v-show="showArticle">
          <div class="a-con">
            <div class="header">{{ $t('f93572dc20') }}<span class="close" @click="changeArticle(false)"></span></div>
            <div class="head">{{ title }}</div>
            <div class="body">{{ detailText }}</div>
          </div>
        </div>
        <div class="message" v-show="showMessage">
          <div class="m-left">{{ $t('0350555272') }}</div>
          <div class="m-right" @click="goCollect">
            <div class="text">{{ $t('5aa512fef5') }}</div>
            <span class="logo"></span>
          </div>
        </div>
        <div class="b-left" @click="rightSlide" v-if="showInfo && last != null"></div>
        <div class="b-right" @click="leftSlide" v-if="showInfo && next != null"></div>
        <span class="noNet" v-if="noNetWork">{{ message }}</span>
      </div>
      <div style="min-height: 100vh" v-empty="empty" :empty-text="emptyText" v-else></div>
    </v-touch>
  </div>
</template>
<script>
import { getDetail, collect } from '@/api/apiList';
import { mapState } from 'vuex';
import { getCookie } from '@/common';
export default {
  data() {
    return {
      id: 1,
      title: '',
      detailText: '',
      hasCollect: 0,
      collectNum: 0,
      showInfo: false,
      showArticle: false,
      showMessage: false,
      empty: '',
      emptyText: $t('21efd88b67'),
      show: true,
      imgUrl: '',
      noNetWork: false,
      message: $t('81d76b746b'),
      show: true,
      last: null,
      next: null,
      oldId: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.imgUrl = '';
      document.title = $t('6ab5f11fbd');
      vm.id = to.query.id;
      vm.type = to.query.type;
      vm.content = to.query.content;
      vm.group = to.query.group;
      vm.slideId = to.query.slideId;
      vm.renderView();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.imgUrl = '';
    this.content = '';
    next();
  },
  provide() {
    return {
      group: () => this.selectGroup,
    };
  },
  methods: {
    renderView() {
      if (!navigator.onLine) {
        // this.$router.push(`/noNet`);
        window.location.href =
          'client://client.html?action=ymtz^webid=2804^mode=new^url=' +
          location.origin +
          location.pathname +
          '/noNet';
      }
      this.title = '';
      this.detailText = '';
      this.showInfo = false;
      this.showArticle = false;
      this.showMessage = false;
      this.hasCollect = 0;
      this.collectNum = 0;
      this.last = null;
      this.next = null;
      this.getData();
    },
    goCollect() {
      // if (window.isThs) {
      //   window.callNativeHandler('NotifyNativeEventToWeb', {}, () => {});
      // }
      // this.$router.push(`/collect`);
      window.location.href =
        'client://client.html?action=ymtz^webid=2804^mode=new^url=' +
        location.origin +
        location.pathname +
        '/#/collect';
    },
    rightSlide() {
      if (this.last === null) {
        return;
      }
      this.id = this.last;
      this.slideId = this.last;
      this.$refs.detail.scrollIntoView();
      this.renderView();
    },
    leftSlide() {
      if (this.next === null) {
        return;
      }
      this.id = this.next;
      this.slideId = this.next;
      this.$refs.detail.scrollIntoView();
      this.renderView();
    },
    press() {
      this.$Talog({
        id: `${window.platformPre}_tushuoshuju.xiangqing.xiazai`,
      });
      setTimeout(() => {
        this.$Talog({
          id: 'iFinD_appStore_tssj_mobile_download',
          img_id: this.id,
        });
      }, 500);
      let url = location.protocol + this.imgUrl;
      console.log(url);
      window.callNativeHandler(
        'displayImageThumbnail',
        {
          currentIndex: 0,
          originImages: [url],
          detailImages: [url],
        },
        () => {
          console.log('displayImageThumbnail');
        }
      );
    },
    async collectChange() {
      const oldStatus = this.hasCollect;
      const action = Number(!this.hasCollect);
      this.hasCollect = !oldStatus;
      let res = await collect({
        id: +this.id,
        action: action,
      }).catch(error => {
        this.hasCollect = oldStatus;
        this.noNetWork = true;
        setTimeout(() => {
          this.noNetWork = false;
        }, 1000);
      });
      if (res && res.code === 1) {
        if (this.hasCollect) {
          this.$Talog({
            id: `${window.platformPre}_tushuoshuju.xiangqing.shoucang`,
          });
          setTimeout(() => {
            this.$Talog({
              id: 'iFinD_appStore_tssj_mobile_favour',
              img_id: this.id,
            });
          }, 500);
          this.showMessage = true;
          setTimeout(() => {
            this.showMessage = false;
          }, 3000);
        } else {
          this.collectNum = this.collectNum - 1 < 0 ? 0 : this.collectNum - 1;
          this.$Talog({
            id: `${window.platformPre}_tushuoshuju.xiangqing.quxiaoshoucang`,
          });
        }
        this.showArticle = false;
      } else {
        if (res === 401) {
          this.message = $t('62a4a22dc0');
        } else {
          this.message = $t('097e5cfa00');
        }
        this.hasCollect = oldStatus;
        this.noNetWork = true;
        setTimeout(() => {
          this.noNetWork = false;
        }, 2000);
      }
    },
    hideInfo() {
      this.showInfo = !this.showInfo;
      this.showMessage = false;
      this.changeArticle(false);
    },
    changeArticle(val) {
      this.showArticle = val;
    },
    async getData() {
      let params = {
        id: this.id,
        type: this.type,
        content: this.content,
        slideId: this.slideId,
      };
      if (this.group !== '') {
        params.type = 3;
        params.tagType = this.group;
      }
      if(params.tagType == 0){
        params.type = 1
      }
      let res = await getDetail(params).catch(error => {
        this.empty = 'm-error';
        this.emptyText = $t('866b795eae');
      });
      if (res && res.code === 1) {
        let { data } = res;
        if (!data.id) {
          this.id = this.oldId;
          this.$refs.detail.scrollIntoView();
          this.renderView();
        }
        this.title = data.title;
        this.detailText = data.content;
        this.hasCollect = data.collectStatus === 1;
        this.collectNum = +data.collectNum;
        this.imgUrl = data.url;
        this.last = data.last;
        this.next = data.next;
        this.showInfo = true;
        this.$refs.detail.scrollIntoView();
      } else {
        this.error = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  background: #000000;
  min-height: 100vh;
  display: flex;
  align-items: center;
  .img {
    margin: 12px 0;
    position: relative;
    width: 100%;
    img {
      width: 100%;
      pointer-events: none
      // user-select: none;
    }
    .img-bottom {
      width: 100%;
      height: 75px;
      background: #000000;
    }
  }
  .img-info {
    position: fixed;
    width: 100%;
    padding: 0 16px;
    bottom: 0;
    transform: translate(0, -87px);
    // animation: move 0.5s linear;
    @keyframes move {
      0% {transform: translate(0, 0px)}
      50% {transform: translate(0, -47px)}
        100% {transform: translate(0, -87px)}
    }
    transition: 1s;
    z-index: 9;
    .title {
      width: 100%;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    .text {
      width: 100%;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 22px;
      font-weight: 400;
    }
  }
  .footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 16px;
    height: 75px;
    background: rgba(23, 23, 23, 0.9);
    .left {
      display: inline-flex;
      align-items: center;
      .collect {
        width: 17px;
        height: 17px;
        background: url(~@/assets/images/m_collect.svg) no-repeat 100% 100%;
        z-index: 998;
        display: inline-block;
        margin-right: 4px;
      }
      .hasCollect {
        background: url(~@/assets/images/m_hasCollect.svg) no-repeat 100% 100%;
      }
      .text {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.84);
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .right {
      display: inline-flex;
      align-items: center;
      position: absolute;
      right: 16px;
      top: 16px;
      .text {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.84);
        letter-spacing: 0;
        line-height: 13px;
        font-weight: 400;
        margin-right: 4px;
      }
      .logo {
        width: 16px;
        height: 16px;
        background: url(~@/assets/images/right.svg) no-repeat 100% 100%;
        z-index: 998;
        display: inline-block;
      }
    }
  }
  .zhe {
    position: fixed;
    bottom: 75px;
    width: 100%;
    height: 324px;
    background-image: linear-gradient(180deg, rgba(10,10,10,0) 0%, rgba(10,10,10,0.76) 100%);
  }
  .article {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    width: 100vw;
    min-height: 100vh;
    bottom: 0;
    .a-con {
      background: #ffffff;
      border-radius: 12px 12px 0 0;
      position: absolute;
      bottom: 0;
      padding: 0 16px 26px 16px;
      width: 100%;
      height: 74vh;
      .header {
        position: relative;
        height: 52px;
        line-height: 52px;
        margin-bottom: 12px;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        font-size: 18px;
        color: #323232;
        letter-spacing: 0;
        font-weight: 500;
        .close {
          position: absolute;
          top: 19px;
          right: 4px;
          width: 14px;
          height: 14px;
          display: inline-block;
          background: url(~@/assets/images/close_jp.svg) no-repeat 100% 100%;
        }
      }
      .head {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #323232;
        letter-spacing: 0;
        text-align: justify;
        line-height: 32px;
        font-weight: 500;
        margin-bottom: 8px
      }
      .body {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.84);
        letter-spacing: 0;
        text-align: justify;
        line-height: 26px;
        font-weight: 400;
      }
    }
  }
  .message {
    width: calc(100% - 32px);
    background: rgba(25, 25, 25, 0.94);
    border-radius: 8px;
    padding: 12px 14px;
    position: fixed;
    left: 16px;
    bottom: 87px;
    display: flex;
    justify-content: space-between;
    z-index: 9;
    .m-left {
      font-size: 14px;
      color: #ffffff;
      font-weight: 500;
    }
    .m-right {
      display: inline-flex;
      align-items: center;
      .text {
        font-size: 14px;
        color: #ffffff;
        font-weight: 500;
        margin-right: 4px;
        user-select: auto
      }
      .logo {
        width: 16px;
        height: 16px;
        background: url('~@/assets/images/right.svg') no-repeat 100% 100%;
        display: inline-block;
      }
    }
  }
}
.noNet {
  padding: 12px 16px;
  background: #3b3b3b;
  border-radius: 6px;
  color: rgb(255, 255, 255, 0.84);
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
// .v-touch ,.detail ,.img{
//   touch-action: pan-y !important;
// }
  .b-left {
    width: 48px;
    height: 48px;
    background: url(~@/assets/images/left.svg) no-repeat 100% 100%;
    position: fixed;
    left: 4px;
    top: 50vh;
    cursor: pointer;
    z-index: 999;
    &:hover {
      background: url(~@/assets/images/left_hover.svg) no-repeat 100% 100%;
    }
  }
  .b-right {
    width: 48px;
    height: 48px;
    background: url(~@/assets/images/next.svg) no-repeat 100% 100%;
    position: fixed;
    right: 4px;
    top: 50vh;
    cursor: pointer;
    z-index: 999;
    &:hover {
      background: url(~@/assets/images/next_hover.svg) no-repeat 100% 100%;
    }
  }
</style>
